// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9417c611","796":"f774ae3b"}[chunkId] + ".chunk.js";
};